import { render, staticRenderFns } from "./SelectableDynamicAttributes.vue?vue&type=template&id=64503b60&"
import script from "./SelectableDynamicAttributes.vue?vue&type=script&lang=ts&"
export * from "./SelectableDynamicAttributes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports